export const buildAddressPreviewEntries = ({
  definitions,
  pendingValues,
  getCurrentValue,
}) =>
  definitions.map(([fieldName, label]) => {
    const currentValue = getCurrentValue(fieldName) ?? "";

    return {
      fieldName,
      label,
      currentValue,
      nextValue: pendingValues?.[fieldName] ?? currentValue,
    };
  });
